import { Component, OnInit, Inject } from '@angular/core';
import { MatDialogRef } from "@angular/material/dialog";
import { MAT_DIALOG_DATA } from "@angular/material/dialog";
import { AngularFirestore } from 'angularfire2/firestore';

@Component({
  selector: 'app-dialog',
  templateUrl: './dialog.component.html',
  styleUrls: ['./dialog.component.scss']
})
export class DialogComponent implements OnInit {
  failed = false;

  constructor(
    public dialogRef: MatDialogRef<DialogComponent>,
    private afs: AngularFirestore,
    @Inject(MAT_DIALOG_DATA) public data: any) {
  }

  ngOnInit() {
  }

  changeTextCategory(string) {
    return string
      .trim()
      .replace(/ö/g, 'o')
      .replace(/Ö/g, 'o')
      .replace(/ç/g, 'c')
      .replace(/Ç/g, 'c')
      .replace(/ş/g, 's')
      .replace(/Ş/g, 's')
      .replace(/ı/g, 'i')
      .replace(/İ/g, 'i')
      .replace(/ğ/g, 'g')
      .replace(/Ğ/g, 'g')
      .replace(/ü/g, 'u')
      .replace(/Ü/g, 'u')
      .replace('&', 've')
      .replace(/,/g, '')
      .replace(/-/g, '')
      .replace(/\./g, '_')
      .replace(/\'/g, '')
      .replace(/\s/g, '_').toLowerCase();
  }

  deleteBrand(): void {
    this.afs.collection('brands').ref.where('uniqueName', '==', this.data.key).get().then(isDelete => {
      if (!isDelete.empty) {
        this.afs.collection('brands').doc(isDelete.docs[0].id).delete();
      }
    }).then(() => {
      this.afs.collection('entities').ref.where('uniqueName', '==', this.data.key).get().then(data => {
        if (!data.empty) {
          this.afs.collection('entities').doc(data.docs[0].id).delete();
        }
      })
    })

  }

  close() {
    this.dialogRef.close();
  }


}



// WEBPACK FOOTER //
// C:/Users/Lenovo/Desktop/bigadviceadminSkeleton/src/app/main/content/brand-list/dialog/dialog.component.ts